import React from 'react';
import Button from '@mui/material/Button';
import SuccessProps from '.';
import Container from './styles';

function Success({
  onNextStep,
}: SuccessProps) {
  return (
    <Container>
      <Button type="submit" variant="outlined" onClick={() => onNextStep()}>OK</Button>
    </Container>
  );
}

export default Success;
